import React, { useEffect, useState } from 'react';
export function FloatingCTA() {
  const images = ['https://uploadthingy.s3.us-west-1.amazonaws.com/1BfG5o9hUPR1QrMjxJQM5M/Image_800x800.webp', 'https://uploadthingy.s3.us-west-1.amazonaws.com/ntK1XQFxqjK4NWrjhDQwYL/Image_1000x1000_%281%29.webp', 'https://uploadthingy.s3.us-west-1.amazonaws.com/8QczgcL9ty8Bv8Zk8NXN5c/Image_1000x1000_%282%29.webp', 'https://uploadthingy.s3.us-west-1.amazonaws.com/fFhVzbyTM7m4mnHxg8vvSd/Image_800x800_%281%29.webp', 'https://uploadthingy.s3.us-west-1.amazonaws.com/dSDXr6KSfwg8qPhswdh8xc/Capture-2025-06-27-030702.png'];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex(prevIndex => (prevIndex + 1) % images.length);
    }, 7000);
    return () => clearInterval(interval);
  }, [images.length]);
  return <div className="hidden lg:block fixed top-32 right-4 w-72 max-w-sm bg-white rounded-lg shadow-xl border border-gray-200 p-4 max-h-[90vh] overflow-y-auto" data-id="element-119">
      <h3 className="text-2xl font-bold text-center mb-1 mt-2" data-id="element-120">Recommended:</h3>
      <div className="flex justify-center mb-1" data-id="element-121">
        {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-6 h-6 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" data-id="element-122">
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-123" />
          </svg>)}
      </div>
      <p className="text-lg text-center mb-2" data-id="element-124">4.9 | 3,788 Reviews</p>
      <div className="text-center mb-1" data-id="element-125">
        <span className="text-2xl font-bold" data-id="element-126">The Nice Shoes</span>
      </div>
      <p className="text-sm text-center text-gray-700 mb-2" data-id="element-127">
        Barefoot Day-to-Day, Running, and Hiking Shoes
      </p>
      <div className="flex justify-center mb-4 h-40 overflow-hidden" data-id="element-128">
        <img src={images[currentImageIndex]} alt={`The Nice Shoes - Style ${currentImageIndex + 1}`} className="w-auto h-full object-contain" data-id="element-129" />
      </div>
      <ul className="space-y-2 mb-4 text-base" data-id="element-130">
        <li className="flex items-start" data-id="element-131">
          <div className="flex-shrink-0 w-6 h-6 bg-green-700 rounded-full flex items-center justify-center mr-2" data-id="element-132">
            <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20" data-id="element-133">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-134" />
            </svg>
          </div>
          <span data-id="element-135">Helps reduce Foot Pain & Inflammation</span>
        </li>
        <li className="flex items-start" data-id="element-136">
          <div className="flex-shrink-0 w-6 h-6 bg-green-700 rounded-full flex items-center justify-center mr-2" data-id="element-137">
            <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20" data-id="element-138">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-139" />
            </svg>
          </div>
          <span data-id="element-140">
            Helps relieve Your Foot & Arch Pain From Plantar Fasciitis
          </span>
        </li>
        <li className="flex items-start" data-id="element-141">
          <div className="flex-shrink-0 w-6 h-6 bg-green-700 rounded-full flex items-center justify-center mr-2" data-id="element-142">
            <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20" data-id="element-143">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-144" />
            </svg>
          </div>
          <span data-id="element-145">Walk or Work Up To 12 Hours With No Trouble</span>
        </li>
        <li className="flex items-start" data-id="element-146">
          <div className="flex-shrink-0 w-6 h-6 bg-green-700 rounded-full flex items-center justify-center mr-2" data-id="element-147">
            <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20" data-id="element-148">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-149" />
            </svg>
          </div>
          <span data-id="element-150">
            Light as Air with Cushioned Footbed — For warm days, long walks, and
            everyday movement.
          </span>
        </li>
      </ul>
      <a href="https://www.theniceshoes.store/" className="w-full bg-green-700 hover:bg-green-800 text-white font-bold py-3 px-3 rounded-lg text-lg flex items-center justify-center transition-all cursor-pointer" data-id="element-151">
        Check Availability
        <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-152">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" data-id="element-153" />
        </svg>
      </a>
    </div>;
}